var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHat2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50mm",
    height: 130.923,
    viewBox: "0 0 50 34.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -262.36)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.9177 0 0 .9177 157.316 200.802)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    transform: "rotate(180 -64.708 44.927) scale(.2607)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-24.449 1.716-25.632 24.714c0 0 4.82 19.386-7.381 23.163 0 0-13.841.686-13.35-25.694 0 0-20.59-79.605 90.814-79.605h12.182v38.111"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    transform: "matrix(.2607 0 0 -.2607 -158.945 89.855)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-24.449 1.716-25.632 24.714c0 0 4.82 19.386-7.381 23.163 0 0-13.841.686-13.35-25.694 0 0-20.59-79.605 90.814-79.605h12.182v38.111"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    transform: "matrix(.2607 0 0 -.2607 -128.464 95.06)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f2dfcd",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s-13.634 99.022-53.059 107.334h-14.457C-106.939 99.022-120.573 0-120.573 0c23.231-8.798 51.635-8.854 60.286-8.637C-51.634-8.854-23.232-8.798 0 0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2607 0 0 -.2607 -158.437 87.618)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#bf4747",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0s57.648-27.403 106.932 0c0 0 7.216-12.122 8.038-31.834 0 0-49.445-32.854-120.574 0 0 0-1.112 22.93 5.604 31.834"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.2607 0 0 -.2607 -139.923 90.743)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5aa0a",
    fillOpacity: 1,
    fillRule: "nonzero",
    stroke: "none",
    d: "M0 0l2.307-20.835-19.263 8.268-19.102-8.632 1.911 20.874-14.113 15.5 20.445 4.634 10.378 18.211 10.725-18.011 20.527-4.244z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHat2);
export default __webpack_public_path__ + "static/media/hat2.305aa7fbac8b98c6fd6d9d3ee80736d8.svg";
export { ForwardRef as ReactComponent };